import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { RESERVE_SCROLLBAR_GUTTER_ATTR } from '../../theme/constants/paper';

const RoundedWhiteBox = React.forwardRef((
  { children, hasManyOptions, sx, ...props },
  ref,
) => (
  <Box
    ref={ref}
    overflow="auto !important"
    sx={(_theme) => ({
      bgcolor: 'white',
      borderRadius: 6,
      borderTopLeftRadius: hasManyOptions ? 0 : 'none',
      px: 4,
      py: 3,
      [_theme.breakpoints.down('md')]: {
        px: 1,
        py: 1,
        borderRadius: 0,
        height: '100%',
        borderTopLeftRadius: 0,
      },
      [`&:has([${RESERVE_SCROLLBAR_GUTTER_ATTR}])`]: {
        scrollbarGutter: 'stable',
      },
      ...sx,
    })}
    {...props}
  >
    {children}
  </Box>
));

export default RoundedWhiteBox;

RoundedWhiteBox.propTypes = {
  children: PropTypes.node.isRequired,
  hasManyOptions: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  sx: PropTypes.object,
};

RoundedWhiteBox.defaultProps = {
  hasManyOptions: false,
  sx: {},
};
